import React from 'react';
import PropTypes from 'prop-types';
import { Button, Glyphicon } from 'react-bootstrap';
import { CSVLink } from 'react-csv';

const CSVButton = props => (
  <CSVLink
    headers={props.header || []}
    data={props.data || []}
    filename={props.filename || 'FoodCompositionData.csv'}
    target='_self'
    rel='noopener noreferrer'
  >

    <Button >
      <Glyphicon glyph="download-alt" /> save as CSV
    </Button>

  </CSVLink>
);

CSVButton.propTypes = {
  header: PropTypes.array,
  data: PropTypes.array,
  filename: PropTypes.string,
};

export default CSVButton;



// WEBPACK FOOTER //
// ./src/components/util/CSVButton.js